import { ProductTagBase } from '../ProductTagBase';
import { isDate, isNumber } from '@fxts/core';
import klass from '../style/ProductTag.module.scss';
import { humanReadableNumberV2 } from '@shared/utils/formatter';
import { differenceInHours, intervalToDuration } from 'date-fns';

/**
 * @figma
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=21842-60347&m=dev
 */
export class NftTag extends ProductTagBase<Date | number> {
  protected makeLabel(): string | undefined {
    if (isDate(this.data.value)) {
      const currentTime = new Date();
      const saleEndDate = this.data.value;
      const hoursLeft = differenceInHours(saleEndDate, currentTime);

      // 1. 168시간 이상
      if (hoursLeft >= 168) {
        return undefined;
      } else if (hoursLeft >= 24) {
        // 2. 24시간 이상 AND 168시간 미만
        const daysLeft = Math.floor(hoursLeft / 24);

        // `N일 남았어요!`
        return ET('mps2::product::tag::period_limited_day', {
          day: daysLeft,
          lng: this.data.lang,
        });
      } else if (currentTime < saleEndDate) {
        // 3. 24시간 미만

        // duration을 HH:MM:SS 형식으로 포맷팅
        const duration = intervalToDuration({ start: currentTime, end: saleEndDate });
        const hours = String(duration.hours || 0).padStart(2, '0');
        const minutes = String(duration.minutes || 0).padStart(2, '0');
        const seconds = String(duration.seconds || 0).padStart(2, '0');

        return ET('mps2::product::tag::period_limited', {
          time: `${hours}:${minutes}:${seconds}`,
          lng: this.data.lang,
        });
      }
    } else if (isNumber(this.data.value)) {
      const formattedCount = humanReadableNumberV2.to(this.data.value, this.data.lang === 'kr');

      return ET('mps2::product::tag::quantity_limited', {
        stock: `${formattedCount.value}${formattedCount.unit}`,
        lng: this.data.lang,
      });
    }
  }

  protected styles(): string {
    return klass.nft;
  }

  isTimerNeeded(): boolean {
    return isDate(this.data.value);
  }
}
